import { User } from 'oidc-client-ts';

/**
 * The claims this portal reads from the id token. oidc-client-ts types unknown claims as
 * `unknown`, so profiles are read through this.
 */
export interface PortalClaims {
  sub: string;
  name?: string;
  role?: string[] | string;
  subportal_user?: boolean;
  ImpersonatorId?: string;
}

export const getClaims = (user: User): PortalClaims => user.profile as unknown as PortalClaims;

export interface LoginDetails {
  isSignedIn: boolean;
  user?: LoginUserDetails;
  impersonationBlocked: boolean;
}

/**
 * An interface for holding user login details.
 */
export interface LoginUserDetails {
  name: string;
  email: string;
  user: User;
  isCellhireUser: boolean;
  isCellhireSuperUser: boolean;
  subportalUser: boolean;
  impersonatorId?: string;
}

/**
 * Gets the default login details.
 */
export const getDefaultLoginDetails = (): LoginDetails => {
  return {
    isSignedIn: false,
    impersonationBlocked: false
  };
};
